import { Condition, RuntimeModel, http } from '@kunlun/dependencies';
import {graphqlQueryFormatter, stringifyToGraphql} from '../../../../utils/serialize';

const createOrderEnums = ['cartGroupType', 'deliveryCycle', 'prepaymentRate', 'addCartSource'];

export const quicklyAdd = async (rModel: RuntimeModel, params: { code: string; orderNum: number; salesOrganizationCode: any; relationApplyId:string; buyerPartnerId:string }) => {
  const gql = `
      {
	      deliAriesSellerPaperItemQuery {
	      	queryPage(
	      		page: { currentPage: 1, size: 1 }
	      		queryWrapper: {
	      			rsql: "(1==1) and ((1==1) and (code=like='${params.code}'))"
	      			queryData: { code: "${params.code}", orderNum: "${params.orderNum}", name: null, itemNumber: null, salesOrganizationCode: "${params.salesOrganizationCode}", ${
    params.relationApplyId ? `relationApplyId: "${params.relationApplyId}",` : ''
  } ${params.buyerPartnerId ? `buyerPartnerId: "${params.buyerPartnerId}",` : ''}  }
	      		}
	      	) {
	      		content {
	      			salesOfficeId
	      			customerCode
	      			itemTplCode
	      			salesOrganizationCode
	      			itemTplId
	      			materialGroupCode
	      			deliMaterialGroup {
	      				code
	      				name
	      				id
	      			}
	      			brand {
	      				code
	      				name
	      				id
	      			}
	      			code
	      			name
	      			outCode
	      			itemNumber
	      			barCode
	      			priceType
	      			startOrderNum
	      			minPalletNum
	      			orderNum
	      			startOrderUnit {
	      				code
	      				name
	      				id
	      			}
	      			startUnitCode
	      			id
	      			brandCode
	      			lineTotalItemWeight
	      		}
	      		totalPages
	      		totalElements
	      	}
	      }
      }
    `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));
  return res.data.deliAriesSellerPaperItemQuery.queryPage.content;
};
export const queryGoodsData = async (
	rModel: RuntimeModel,
	params: { code: string; name: string; itemNumber: string; id: string, salesOrganizationCode:string, relationApplyId:string, buyerPartnerId:string },
	pageConfig: { page: number; pageSize: number }
) => {
	const condition = new Condition('(1==1) and (1==1)');
	for (const [key, value] of Object.entries(params)) {
		if (!value) continue;
		let cond = new Condition(key);
		if (key === 'id') {
			cond = new Condition(`id=out=(${params.id})`);
		}
		if (['id'].includes(key)) {
			condition.and(cond);
		}else if(['salesOrganizationCode'].includes(key) || ['relationApplyId'].includes(key) || ['buyerPartnerId'].includes(key)){


		} else {
			cond.like(value);
			condition.and(cond);
		}
	}
	condition.toString();
	const gql = `
	{
	deliAriesSellerPaperItemQuery {
		queryPage(
			page: { currentPage: ${pageConfig.page}, size: ${pageConfig.pageSize} }
			queryWrapper: {
				rsql: "${condition.toString()}"
				queryData: {${params.code ? `code:"${params.code}",` : ''} ${params.name ? `name: "${params.name}",` : ''
		} ${params.itemNumber ? `itemNumber: "${params.itemNumber}",` : ''} ${params.relationApplyId ? `relationApplyId: "${params.relationApplyId}",` : ''} ${params.buyerPartnerId ? `buyerPartnerId: "${params.buyerPartnerId}",` : ''} ${params.salesOrganizationCode?`salesOrganizationCode:${params.salesOrganizationCode}`:''} }
			}
		) {
			content {
				salesOfficeId
				customerCode
				itemTplCode
				salesOrganizationCode
				itemTplId
				materialGroupCode
				subBrand
				paperType
				factoryPrice
				discountRate
				deliMaterialGroup {
					code
					name
					id
				}
				brand {
					code
					name
					id
				}
				code
				name
				outCode
				itemNumber
				barCode
				priceType
				startOrderNum
				minPalletNum
				startOrderUnit {
					code
					name
					id
				}
				startUnitCode
				id
				brandCode
			}
			totalPages
			totalElements
		}
	}
}

	`;
	const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));
	return res?.data?.deliAriesSellerPaperItemQuery?.queryPage ?? [];
};
export const orderPreview = async (
	rModel: RuntimeModel,
	params: { formData: Record<any, any> },
	isPromotionOrder: boolean
) => {
	const gql = `
    mutation {
      deliAriesSellerPaperOrderMutation {
        previewPaperOrder (
          data: ${stringifyToGraphql(params.formData, createOrderEnums, rModel)}
        ) {
          originPartnerCode
          hasIssuingMethod
          tradeOrderType
          originPartner {
               name
               id
          }
          issuingMethodEnum
          pcItemDetail {
               itemTplCode
               itemTplId
               materialGroupCode
               subBrand
               paperType
               factoryPrice
               discountRate
               deliMaterialGroup {
                    code
                    name
                    id
               }
               brand {
                  code
                  name
                  id
               }
               code
               name
               outCode
               itemNumber
               barCode
               priceType
               startOrderNum
               minPalletNum
               startOrderUnit {
                    code
                    name
                    id
               }
               startUnitCode
               id
               brandCode
               orderNum
               lineTotalItemWeight
          }
        }
      }
    }
    `;
	console.log(params)
	const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

	return res.data.deliAriesSellerPaperOrderMutation.previewPaperOrder;
};
